export default __webpack_public_path__ + "static/media/Card Error.77451f2e.svg";